// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "vendor" + "." + "e6e2fe51785e22d0f0b1" + ".css";
};